/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('App_Resource',["$resource","$location",
        function ($resource,$location)
        {
            var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
            return $resource(baseUrl+'rest/app/:id',{}, {
                query: { method: 'GET', isArray: true },
                get: { method: 'GET' },
                getByCode: { method: 'GET', url:baseUrl+'rest/app/code/:code' }
            });
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('App',["App_Resource","AppAttribute","AppData",
        function (App_Resource,AppAttribute,AppData)
        {
            var App = function (resource)
            {
                this.id = "";
                this.isDeleted = false;

                this.code = "";
                this.appAttributes = [];
                this.version=null;
                if(resource !== undefined && resource !== null)
                    this.setValues(resource);

                AppData.add(this);
            };

            App.prototype.setId = function(id)
            {
                if (!this.id)
                    this.id = id;
            };
            App.prototype.getId = function()
            {
                return this.id;
            };
            App.prototype.setCode = function(code)
            {
                this.code = code;
            };
            App.prototype.getCode = function()
            {
                return this.code;
            };
            App.prototype.setValues = function(resource)
            {
                this.id = resource.id;
                this.isDeleted = resource.isDeleted;

                this.code = resource.code;
                this.appAttributes = resource.appAttributes;
                if(resource.version)
                    this.version=resource.version;
            };
            App.prototype.getObjectResource = function()
            {
                var newApp = new App_Resource();

                newApp.id = this.id;
                newApp.isDeleted = this.isDeleted;
                newApp.code = this.code;
                newApp.appAttributes = this.appAttributes;

                return newApp;
            };
            App.prototype.simpleAddAppAttribute = function(appAttribute)
            {
                var index = this.appAttributes.indexOf(appAttribute);
                if (index == -1)
                    this.appAttributes.push(appAttribute);
            }
            App.prototype.addAppAttribute = function(appAttribute)
            {
                if(appAttribute.code !== undefined && appAttribute.value !== undefined && ((appAttribute.code !== null && appAttribute.value !== null)||(appAttribute.text !== null && appAttribute.text !== null)))
                {
                    var newAppAttribute;
                    newAppAttribute = new AppAttribute(appAttribute.code, appAttribute.value, appAttribute.text);

                    var index = this.appAttributes.indexOf(newAppAttribute);
                    if (index !== -1)
                        this.appAttributes[index].setValues(appAttribute.code, appAttribute.value,appAttribute.text);
                    else
                        this.appAttributes.push(newAppAttribute);
                }
            };
            App.prototype.removeAppAttribute = function(appAttribute)
            {
                var index = this.appAttributes.indexOf(appAttribute);
                if(index !== -1)
                    this.appAttributes.splice(index, 1);
            };
            App.prototype.getAppAttribute = function(attributeCode)
            {
                for(var i=0;i<this.appAttributes.length;i++)
                    if(this.appAttributes[i].code === attributeCode)
                        return this.appAttributes[i];

                return null;
            };
            App.prototype.setAppAttribute = function(attributeCode,newValue)
            {
                for(var i=0;i<this.appAttributes.length;i++)
                    if(this.appAttributes[i].code === attributeCode)
                        this.appAttributes[i].value = newValue;
            };

            return App;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('AppSrv',["$log","ServerSrv","App_Resource","AppData","UserActionData","App",
        function ($log,ServerSrv,App_Resource,AppData,UserActionData,App)
        {
            var appSrv = {};

            appSrv.query = function(successFunction,errorFunction)
            {
                App_Resource.query(
                    {}, //params
                    function (data) {
                        AppData.clear();
                        for(var i=0;i<data.length;i++)
                        {
                            new App(data[i]);
                        }

                        if (successFunction!== undefined)
                            successFunction();
                    },
                    function (data) {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    }
                );
            };
            appSrv.getByCode = function(code,successFunction,errorFunction)
            {
                App_Resource.getByCode(
                    {code:code},
                    function (appRessource) {
                        if (successFunction!=undefined)
                            successFunction(new App(appRessource));
                    },
                    function (data) {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    });
            };
            appSrv.save = function(app,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(appSrv.saveSync, app, successFunction, errorFunction);
            };
            appSrv.saveSync = function(app,successFunction,errorFunction)
            {
                //$timeout (function () {

                var appRes = app.getObjectResource();
                appRes.$save({}, //no params
                    function (data) {
                        try{
                            app.setId(data.id);
                            if (!app.version || (data.version && data.version > app.version))
                                app.version = data.version;
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };
            appSrv.remove = function(app,successFunction,errorFunction)
            {
                AppData.remove(app);
                ServerSrv.startSavingProcess(appSrv.removeSync, app, successFunction, errorFunction);
            };
            appSrv.removeSync = function(app,successFunction,errorFunction)
            {
                //$timeout (function () {

                var appRes = app.getObjectResource();
                appRes.$remove({id:app.getId()}, //no params
                    function (data) {
                        try{
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };

            return appSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('AppData',[
        function ()
        {
            var appData =
            {
                appList : [], // app list for the entire application
                deletedAppList : [] // deleted app list for the entire application
            };

            appData.add = function(app)
            {
                if(!app.isDeleted)
                    this.appList.push(app);
                else
                    this.deletedAppList.push(app);
            };
            appData.remove = function(app) //Soft Remove
            {
                if(!app.isDeleted) {
                    var indexAppList = this.appList.indexOf(app);
                    if (indexAppList != -1) {
                        this.appList.splice(indexAppList, 1);
                        this.deletedAppList.push(app);
                        app.isDeleted = true;
                    }
                }
            };
            appData.getAppList = function()
            {
                return this.appList;
            };
            appData.getAppByCode = function(appCode)
            {
                for(var i=0;i<this.appList.length;i++)
                {
                    if(this.appList[i].getCode() == appCode)
                    {
                    return this.appList[i];
                    }
                }
                return null;
            }
            appData.clear = function()
            {
                this.appList = [];
                this.deletedAppList = [];
            };


            return appData;
        }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/App.js